import { render, staticRenderFns } from "./UserProfileNotification.vue?vue&type=template&id=6709e0e0&scoped=true&"
import script from "./UserProfileNotification.vue?vue&type=script&lang=ts&"
export * from "./UserProfileNotification.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6709e0e0",
  null
  
)

export default component.exports